<p>
    modal-confirm works!
</p>